import { isWholesiesConsentUpdateEnabled, isExplicitConsentEnabled } from '../marketing/wholesiesConsentUpdate';
import addGdprPrivacyPolicy from '../marketing/groupEnrollment';

const toggleContactCheckbox = () => {
  var changeCountryHandler = (e) => {
    var countrySelect = e.target;
    var wrapper = document.querySelector('.js-custom-form__contact-checkbox-block');
    var contactCheckbox = wrapper.querySelector('[type="checkbox"]');
    var gdprCountries = wrapper.dataset.countries.split(' ');

    // --- Wholesies Temporary Consent Handler
    if (isWholesiesConsentUpdateEnabled()) {
      var implicitConsentText = document.querySelector('.js-implicit-consent');
      if (isExplicitConsentEnabled(countrySelect.value)) {
        wrapper.classList.remove('hidden');
        implicitConsentText.classList.add('hidden');
      } else {
        contactCheckbox.checked = false;
        wrapper.classList.add('hidden');
        implicitConsentText.classList.remove('hidden');
      }

      return;
    }
    // --- END Wholesies Temporary Consent Handler

    var groupEnrollmentNonGdrpMessage = document.querySelector('.js-non-gdpr-countries-privacy-policy');
    if (gdprCountries.includes(countrySelect.value)) {
      wrapper.classList.remove('hidden');
      if (groupEnrollmentNonGdrpMessage) groupEnrollmentNonGdrpMessage.classList.add('hidden');
    } else {
      contactCheckbox.checked = false;
      wrapper.classList.add('hidden');
      if (groupEnrollmentNonGdrpMessage) groupEnrollmentNonGdrpMessage.classList.remove('hidden');
    }
  };

  var loadHandler = () => {
    if (document.querySelector('.js-hide-checkbox-non-gdpr-countries')) {
      if (document.querySelector('.js-non-gdpr-countries-privacy-policy')
        && !document.querySelector('#group-enrollment-gdpr-privacy-policy-link')) addGdprPrivacyPolicy();
      var countrySelect = document.querySelector('.js-custom-form [type="country"], .js-custom-form [type="latam_country"]');
      if (countrySelect) {
        countrySelect.addEventListener('change', changeCountryHandler);
        countrySelect.dispatchEvent(new CustomEvent('change'));
      }
    }
  };

  if (document.readyState === 'loading') {
    // loading hasn't finished yet so it is ok to listen for domcontentloaded
    document.addEventListener('DOMContentLoaded', loadHandler);
  } else {
    loadHandler();
  }
};

export default toggleContactCheckbox;
